import React from 'react'

const SearchIcon = () => {
    
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_113_1465)">
                <path d="M11.5 18C15.366 18 18.5 14.866 18.5 11C18.5 7.13401 15.366 4 11.5 4C7.63401 4 4.5 7.13401 4.5 11C4.5 14.866 7.63401 18 11.5 18Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path fillRule="evenodd" clipRule="evenodd" d="M15.8911 16.4518C16.2813 16.1371 16.6371 15.7813 16.9518 15.3911L21.2803 19.7197C21.5732 20.0126 21.5732 20.4875 21.2803 20.7803C20.9875 21.0732 20.5126 21.0732 20.2197 20.7803L15.8911 16.4518Z" fill="black"/>
            </g>
            <defs>
                <clipPath id="clip0_113_1465">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default SearchIcon